/** Client-side referral link + return visit coupon prompt (codes match server-created coupons). */

export const REFERRAL_PENDING_COPY_KEY = 'makereels_referral_pending_coupon_v1';

/** Shown in the shared message — friend uses this at signup. */
export const REFERRAL_FRIEND_SHARE_CODE = 'BHA30V';

/** Shown after share on return visit — sharer copies this for themselves. */
export const REFERRAL_SHARER_COPY_CODE = 'AHX476';

function getLocalShareDateDdMmYyyy() {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = String(now.getFullYear());
  return `${dd}${mm}${yyyy}`;
}

export function buildReferralLandingUrl(userId) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const u = new URL('/', origin);
  u.searchParams.set('utm_source', 'referral');
  u.searchParams.set('utm_medium', 'share');
  u.searchParams.set('utm_campaign', 'referral_week');
  u.searchParams.set('utm_content', getLocalShareDateDdMmYyyy());
  u.searchParams.set('ref', userId);
  return u.toString();
}

export function buildReferralShareMessage(landingUrl) {
  const line1 = `👋I tried this thing for making reels with AI with only 1 Tap, kinda nice actually got a free week code if you want- ${REFERRAL_FRIEND_SHARE_CODE}`;
  return `${line1}\n${landingUrl}`;
}

export function persistPendingReferralCoupon({ userId, couponCode }) {
  if (!userId || !couponCode) return;
  try {
    localStorage.setItem(
      REFERRAL_PENDING_COPY_KEY,
      JSON.stringify({
        userId,
        couponCode,
        savedAt: Date.now(),
      })
    );
    try {
      sessionStorage.removeItem('makereels_referral_return_modal_dismissed_session');
    } catch (_) {}
    window.dispatchEvent(new Event('makereels-referral-pending'));
  } catch (_) {}
}

export function readPendingReferralCoupon() {
  try {
    const raw = localStorage.getItem(REFERRAL_PENDING_COPY_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.userId || !data?.couponCode) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearPendingReferralCoupon() {
  try {
    localStorage.removeItem(REFERRAL_PENDING_COPY_KEY);
  } catch (_) {}
}
